import React from "react";
import SVG from "react-inlinesvg";

import iconGiftBox from "../../../../img/icons/gift-box.svg";
import config from "../../../config";
import { IReview } from "../../../models/reviews.interfaces";
import { ReviewDisclosureCode } from "../constants";

import styles from "./DisclosureCopy.module.scss";

interface IProps {
    review: IReview;
}

export const DisclosureCopy = (props: IProps): React.JSX.Element | null => {
    const disclosureSettings = config.get("REVIEWS_DISCLOSURE_SETTINGS") || {};
    const disclosureCopy = props.review.disclosure_code
        ? disclosureSettings[props.review.disclosure_code]
        : null;
    if (!disclosureCopy) {
        return null;
    }

    const className =
        props.review.disclosure_code === ReviewDisclosureCode.SAMPLING
            ? styles.rootAlt
            : styles.root;

    return (
        <div className={className}>
            {props.review.disclosure_code === ReviewDisclosureCode.SAMPLING && (
                <SVG aria-hidden="true" src={iconGiftBox} />
            )}
            {disclosureCopy}
        </div>
    );
};
